module.exports = __webpack_public_path__ + "img/b_timg.c3eeba44.png";